import React, { useRef, useMemo, useCallback, useState, useEffect } from 'react';
import { ChatMsgLoader } from '../messageBox/ChatComponents/ChatMsgLoader';
import SubHeader from './SubHeader';
import Header from './Header';
import Scroller from './Scroller';
import TypingUsers from './TypingUsers';
import MessageInput from '../messageBox/InputBar/MessageInput';
import MessagesList from './MessageList';
import { useSelector, useDispatch } from 'react-redux';
import { chatType, defaultMessageLimit } from '../ChatController';
import { useQuery, GetQueryParam } from '../../../utils/common'
import { chats } from '../../../router/roleWisePageRoute';
import _ from 'lodash';
import { useNavigate, useParams, useLocation, useMatch } from 'react-router-dom';
import MaterialIconToolTipComponent from '../../../common/MaterialIconToolTip';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { SIA_CHAT_MESSAGE } from '../../../types/conversations';
import axios from 'axios';
import config from '../../../config';
import { clearChatMessages, closeChatRequest, getChatMessages, readMessage } from '../../../actions/chat';
import NatsServiceAll from '../../../utils/nats';
import { DELETE_LIVE_MESSAGE_DATA, EDIT_LIVE_MESSAGE_DATA, LIVE_MESSAGE_DATA, MEMBERS_ADDED_OR_DELETE } from '../../../types/chat';
import development from '../../../config/env/development';
export const scogo_new_chat_created = 'scogo_new_chat_created';

export default function RenderChatMessages({ mainDivClass = '', ticketId = 0, mainChatContanerRef, isSupportTicket = false, showChatHeader = true, handleCloseChat, isChatPopup, handleChatArrowClick, isChatMinimized, getOpenedConversationsIds, chat_id, defaulOpentChecklist = false }) {
    const messageInputRef = useRef();
    const { isConversationMessagesLoading } = useSelector((state) => state.loading);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    const isChatMessagesLoading = useSelector((state) => state.loading.isChatMessagesLoading);
    const isNextChatMessagesLoading = useSelector((state) => state.loading.isNextChatMessagesLoading);
    const {
        mpConversationUserTyping,
        conversationDetails,
        openedConversationUnreadableMessageCount,
        openedConversationMessageIsLatest,
        chatList,
        siaChatMessages
    } = useSelector((state) => state.conversations);
    const chatDetails = useSelector((state) => state.chat.chatDetails);
    let openedConversation = chatDetails?.[chat_id];

    const [uuid, setUuid] = useState()
    const dispatch = useDispatch();
    const [showScrollButton, setShowScrollButton] = useState(false);
    const [replyShow, setReplyShow] = useState(false);
    const [replyToMessage, setReplyToMessage] = useState(null);
    const [unReadMessageId, setUnReadMessageId] = useState("");
    const scrollDivRef = useRef(null);
    const firstMessageRef = useRef(null);
    const messageId = useQuery().get('messageId');
    const chatGptQueryParams = GetQueryParam('chatGpt', Boolean);
    let { chatId } = useParams();
    const [hideCloseIconTimer, setHideCloseIconTimer] = useState(false);
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const openedConversationIdScogoMeet = useQuery().get('openedConversationId');

    if (!chatId) {
        chatId = openedConversationIdScogoMeet;
    }
    const matchChatPage = useMatch(chats.path);

    const chatMessages = useSelector((state) => state.chat.chatMessages);


    let memoizedMessages = useMemo(() => {
        let m = [];
        if (chatMessages[chat_id]) {
            m = chatMessages[chat_id];
        }

        return m
    }, [chatMessages, chat_id]);

    useEffect(() => {
        if (!chat_id && matchChatPage?.pathname === '/chats' && chatGptQueryParams) {
            const id = uuidv4()
            setUuid(id)
            navigate(`${chats.path}/${id}?chatGpt=true`);
            dispatch({ type: SIA_CHAT_MESSAGE, payload: { cleanup: true } })
        }
    }, [chat_id, matchChatPage?.pathname, chatGptQueryParams, dispatch, navigate]);

    useEffect(() => {
        if (chat_id && siaChatMessages.length === 0 && chatGptQueryParams) {
            let message = `Hey! I’m Sia, your Scogo Assistant. How may I assist you today?
I can help you with creating new service tickets or provide details about any existing tickets`
            dispatch({ type: SIA_CHAT_MESSAGE, payload: { msg: { data: message, is_agent: true } } });
            axios.get(`${config.api.siaChatUrl}/v1/agents/cloud-chat-messages/${chat_id}`)
                .then((res) => {
                    const list = res?.data?.map(({ History, created_at, updated_at }) => {
                        let history = JSON.parse(History);
                        return { data: history.data.content, is_agent: history.type === 'ai', created_at, updated_at }
                    }) || [];
                    if (list.length > 0) {
                        dispatch({ type: SIA_CHAT_MESSAGE, payload: { append: false, list } });
                    }
                })
        }
    }, [siaChatMessages, chatId, dispatch, chatGptQueryParams]);

    const isCurrentChatLoading = isConversationMessagesLoading[chat_id];

    const scrollToBottom = useCallback((options) => {
        if (!options?.behavior) {
            // options.behavior = 'smooth';
        }
        let lastDiv = document.getElementById('last_element_after_messages');
        lastDiv?.scrollIntoView(options);
    }, []);

    const handleFileDrop = (ev) => {
        ev.preventDefault();
        let files = [];
        if (ev.dataTransfer.items) {
            files = [...ev.dataTransfer.items].filter((item) => item.kind === 'file' && item.type !== '').map((item) => item.getAsFile());
        } else {
            files = [...ev.dataTransfer.files];
        }
        if (files.length > 0) {
            messageInputRef.current?.onFileSelect?.(files);
        }
    };

    const showCurrentDateOnScroll = () => {
        let chatMsgsRef = scrollDivRef.current;
        let dateDividers = chatMsgsRef && chatMsgsRef.querySelectorAll('.dateDivider');

        let currentLabel = null;
        dateDividers.forEach((dateLabel) => {
            if (chatMsgsRef.scrollTop > dateLabel.offsetTop) {
                currentLabel = dateLabel;
            }
        });

        if (currentLabel) {
            firstMessageRef.current.style.display = 'block';
            firstMessageRef.current.innerText = currentLabel.innerText;
        } else {
            firstMessageRef.current.style.display = 'none';
        }
    };

    useEffect(() => {
        if (openedConversation?.unread_count > 0) {
            dispatch(readMessage({ id: openedConversation.id }))
        }
    }, [openedConversation, dispatch]);

    const getChatMessagesList = useCallback(({ id, limit = 25, q, direction, target_message_id, onSuccess, cursor }) => {
        dispatch(getChatMessages({ id, limit, q, direction, target_message_id, onSuccess, cursor }))
    }, [dispatch]);

    const handleScroll = (event) => {
        let isScrollNotAtBottom = Math.abs(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight) >= 100;
        const scrollOnBottom = Math.abs(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight) <= 1;
        const isScrollAtTop = event.target?.scrollTop === 0;
        setShowScrollButton(isScrollNotAtBottom);

        const isMessageIsEmpty = memoizedMessages[0]?.isLast;
        if (isScrollAtTop && memoizedMessages && !isChatMessagesLoading && !isNextChatMessagesLoading) {
            const firstVisibleMessage = scrollDivRef.current?.querySelector('.message_class_for_scroll');
            const firstMessageId = firstVisibleMessage?.id;

            if (!isMessageIsEmpty) {
                // Save the current scroll position and height before loading new messages
                const scrollHeight = event.target.scrollHeight;
                const scrollTop = event.target.scrollTop;
                getChatMessagesList({
                    id: chat_id,
                    q: chatGptQueryParams,
                    direction: 'up',
                    cursor: firstMessageId,
                    isMessageIsEmpty,
                    onSuccess: () => {
                        setTimeout(() => {
                            const newScrollHeight = event.target.scrollHeight;
                            const heightDifference = newScrollHeight - scrollHeight;

                            if (heightDifference > 0) {
                                event.target.scrollTop = scrollTop + heightDifference;
                            } else if (firstMessageId) {
                                const element = document.getElementById(firstMessageId);
                                if (element) {
                                    element.scrollIntoView({ block: 'start' });
                                }
                            }
                        }, 100);
                    }
                });
            }
        } else if (scrollOnBottom && openedConversation && memoizedMessages.length && !isChatMessagesLoading && !isNextChatMessagesLoading) {
            const lastMessageId = memoizedMessages[memoizedMessages.length - 1]?.id;
            const isMessageIsEmpty = memoizedMessages[memoizedMessages.length - 1]?.isLast;
            if (!isMessageIsEmpty) {
                getChatMessagesList({ id: chat_id, limit: 25, q: '', direction: 'down', cursor: lastMessageId })
            }
        }
        showCurrentDateOnScroll();
    };

    const unReadMessageDiv = (id) => {
        var messageDiv = document.getElementById(id);
        if (messageDiv) {
            _.delay(() => {
                messageDiv.scrollIntoView({ behavior: 'instant' }, true);
            }, 200)
        }
    }

    const openChatInNewTab = () => {
        let url = `/chats/${chat_id}?hideList=true`;
        if (chatGptQueryParams) url = `${url}&chatGpt=true`
        window.open(url, '_blank');
    };

    const closeHelpRequest = useCallback((Id) => {
        dispatch(closeChatRequest({ id: Id, formName: `help-${Id}`, navigate }));
    }, [dispatch, navigate]);

    const icons = () => {
        const openInNew = { name: 'open_in_new', onClick: () => openChatInNewTab(), title: 'Open Chat In New Tab' }
        let icon = [];
        if (chat_id) icon.push(openInNew);
        if (openedConversation?.is_active && openedConversation?.type === chatType.HELP) {
            icon = [
                {
                    name: 'power_settings_new',
                    onClick: () => {
                        closeHelpRequest(chat_id);
                    },
                    title: 'Close Request',
                },
                { name: 'open_in_new', onClick: () => openChatInNewTab(), title: 'Open Chat In New Tab' },
            ];
        }

        icon = icon.filter(({ name }) => {
            if (name === 'open_in_new' && chatGptQueryParams) {
                return false
            }
            return true;
        });

        return icon?.map((e) => {
            return <MaterialIconToolTipComponent key={e?.name} title={e?.title} onClick={() => e.onClick()} materialIconName={e?.name} materialIconClass={`text-scogoprimary hover:text-scogoorange cursor-pointer material-icons ${isChatPopup ? 'text-font14' : 'text-font16'}`} />;
        });
    };

    const getLatestConversationMessages = (delayTime = 500) => {
        if (openedConversationMessageIsLatest?.[chat_id]) {
            scrollToBottom({ block: 'end' });
        } else {
            scrollToBottom({ block: 'end' });
            _.delay(() => {
                const lastMessageId = memoizedMessages[memoizedMessages.length - 1]?.id;
                const isMessageIsEmpty = memoizedMessages[memoizedMessages.length - 1]?.isLast;
                if (!isMessageIsEmpty) {
                    getChatMessagesList({ id: chat_id, limit: 25, q: '', direction: 'down', cursor: lastMessageId })
                }
                let params = new URLSearchParams(window.location.search);
                params.delete('messageId');
                params = params.toString();
                navigate({
                    pathname: window.location.pathname,
                    search: params,
                });
            }, delayTime);
        }
    };

    const onClickReplyMessage = (id) => {
        var messageDiv = document.getElementById(id);
        if (messageDiv) {
            messageDiv.scrollIntoView({}, true);
            messageDiv.className = 'highLightDiv';
            _.delay(() => {
                messageDiv.classList.remove('highLightDiv');
            }, 5000);
        } else {
            let params = new URLSearchParams(window.location.search);
            params.set('messageId', id);
            params = params.toString();
            _.delay(() => {
                navigate({
                    pathname: window.location.pathname,
                    search: params,
                });
            }, 600);
            getChatMessagesList({
                id: chat_id,
                limit: 25,
                q: '',
                target_message_id: id,
                onSuccess: () => {
                    // Use setTimeout to ensure the DOM has been updated with the new messages
                    setTimeout(() => {
                        var messageDiv = document.getElementById(id);
                        if (messageDiv) {
                            messageDiv.scrollIntoView({}, true);
                            messageDiv.className = 'highLightDiv';
                            _.delay(() => {
                                messageDiv.classList.remove('highLightDiv');
                            }, 5000);
                        }
                    }, 100);
                }
            })
        }
    };

    const onReplyClick = (selectedMessage) => {
        setReplyShow(true);
        setReplyToMessage(selectedMessage);
    };

    const conversationUnreadMessageLoaded = conversationDetails?.[chatId] ? true : false // need to fix

    useEffect(() => {
        let unreadCount = openedConversation?.unread_count;
        let unReadMesIndex = -1;
        if (unreadCount === 0 && unReadMessageId?.length > 0) {
            setUnReadMessageId("")
        }
        if (conversationUnreadMessageLoaded && unreadCount && unReadMessageId?.length === 0) {
            unReadMesIndex = memoizedMessages?.length - unreadCount
        } else if (unreadCount < defaultMessageLimit && unreadCount > 0 && unReadMessageId?.length === 0) {
            unReadMesIndex = memoizedMessages?.length - unreadCount
        } else if (unreadCount >= defaultMessageLimit && unReadMessageId?.length === 0) {
            unReadMesIndex = memoizedMessages?.length - defaultMessageLimit
        }
        if (unReadMesIndex >= 0) {
            setUnReadMessageId(memoizedMessages?.[unReadMesIndex]?.id)
            unReadMessageDiv(memoizedMessages?.[unReadMesIndex - 1]?.id)
        }
    }, [openedConversation?.unread_count, memoizedMessages?.length]);


    const memoizedChatDetails = useMemo(() => {
        let d = {};
        if (chatDetails[chat_id]) {
            d = chatDetails[chat_id]
        }
        return d
    }, [chatDetails, chat_id]);

    const closeReply = useCallback(() => {
        setReplyShow(false);
        setReplyToMessage(null);
    }, []);

    useEffect(() => {
        if (messageId) {
            getChatMessagesList({
                id: chat_id,
                limit: 25,
                q: '',
                target_message_id: messageId,
                onSuccess: () => {
                    setTimeout(() => {
                        var messageDiv = document.getElementById(messageId);
                        if (messageDiv) {
                            messageDiv.scrollIntoView({}, true);
                            messageDiv.className = 'highLightDiv';
                            _.delay(() => {
                                messageDiv.classList.remove('highLightDiv');
                            }, 5000);
                        }
                    }, 100);
                }
            })
        } else {
            getChatMessagesList({
                id: chat_id,
                limit: 25,
                q: '',
                onSuccess: () => {
                    setTimeout(() => {
                        if (scrollDivRef.current) {
                            scrollDivRef.current.scrollTop = scrollDivRef.current.scrollHeight;
                        }
                    }, 100);
                }
            });
        }
        return () => {
            dispatch(clearChatMessages({ id: chat_id }))
        }
    }, [dispatch, chat_id, getChatMessagesList, messageId]);

    useEffect(() => {
        if (!chat_id) return;

        const subscribeToTopic = async (topicSuffix, handler) => {
            try {
                const topic = `chat.${chat_id}.${topicSuffix}`;
                const cb = (chunk) => {
                    const parse = JSON.parse(chunk);
                    console.log('parse:', parse)
                    if (config.name === development.name) {
                        console.log(`${topicSuffix} data:`, parse);
                    }
                    if (handler) {
                        handler(parse);
                    }
                };
                await NatsServiceAll.subscribe(topic, cb);
                return topic;
            } catch (error) {
                console.error(`Subscription to ${topicSuffix} failed:`, error);
                return null;
            }
        };

        const subscriptions = [];
        const setupSubscriptions = async () => {
            const messageTopic = await subscribeToTopic('message',
                (data) => dispatch({ type: LIVE_MESSAGE_DATA, payload: { data, loginUserId: newLoggedUserData.user.id } }));
            const deleteTopic = await subscribeToTopic('message.delete', (data) => dispatch({ type: DELETE_LIVE_MESSAGE_DATA, payload: { message_id: data.id, chat_id } }));
            const editTopic = await subscribeToTopic('message.edit', (data) => dispatch({ type: EDIT_LIVE_MESSAGE_DATA, payload: { message_id: data.id, chat_id, content: data.content, is_edited: true } }));
            const membersAddedOrDelete = await subscribeToTopic('members', (data) => {
                if (data.event.endsWith('added') && data.data.members) {
                    const isLoginUserAdded = data.data.members.some(member => member.id === newLoggedUserData.user.id);
                }
                dispatch({ type: MEMBERS_ADDED_OR_DELETE, payload: { ...data, chat_id, loginUserId: newLoggedUserData.user.id, navigate } })
            });

            if (messageTopic) subscriptions.push(messageTopic);
            if (deleteTopic) subscriptions.push(deleteTopic);
            if (editTopic) subscriptions.push(editTopic);
            if (membersAddedOrDelete) subscriptions.push(membersAddedOrDelete);
        };

        setupSubscriptions();

        return () => {
            subscriptions.forEach(topic => {
                NatsServiceAll.unsubscribe(topic);
            });
        };
    }, [chat_id, dispatch, navigate, newLoggedUserData.user.id]);

    const isSubHeaderVisible = useMemo(() => {
        if (window.location.pathname.includes('support/track')) {
            return true;
        }
        let isVisible = false;
        if (memoizedChatDetails.type === chatType.TICKET) {
            isVisible = true;
        }
        return isVisible;
    }, [memoizedChatDetails.type])

    return (
        <div className={`border-2 border-scogogray overflow-hidden ${mainDivClass} `} onDrop={handleFileDrop} onDragOver={(ev) => ev.preventDefault()} >
            <div
                data-chat-panel
                className='relative h-full flex bg-scogoeee'
                style={{
                    flexFlow: 'column',
                }}
            >
                <div className={`flex-initial ${isChatMinimized ? 'fixed z-50 w-[33rem]' : ''}`}>
                    {showChatHeader &&
                        <div onClick={handleChatArrowClick} className={`flex items-center chatContainerHeader bg-slate-200  ${isChatPopup ? 'md:px-1 cursor-pointer' : 'md:px-8'}  px-2 gap-3  `}>
                            <Header
                                loading={isCurrentChatLoading}
                                showProfileImg={openedConversation?.type !== chatType.HELP}
                                icons={icons}
                                isSingleChat={openedConversation?.type === chatType.SINGLE}
                                isTicketchat={openedConversation?.type === chatType.TICKET}
                                chat_id={chat_id}
                                mainChatContanerRef={mainChatContanerRef}
                                handleCloseChat={handleCloseChat}
                                isChatPopup={isChatPopup}
                                openedConversation={openedConversation}
                                handleChatArrowClick={handleChatArrowClick}
                                isChatMinimized={isChatMinimized}
                                getOpenedConversationsIds={getOpenedConversationsIds}
                                unReadMessageId={unReadMessageId}
                                isSupportTicket={isSupportTicket}
                                chatGptQueryParams={chatGptQueryParams}
                                memoizedChatDetails={memoizedChatDetails}
                                memoizedMessages={memoizedMessages}
                            />
                        </div>}
                </div>
                {memoizedChatDetails.type === chatType.TICKET && <div className='overflow-y-auto flex-initital'>
                    <SubHeader memoizedChatDetails={memoizedChatDetails} isSupportTicket={isSupportTicket} isChatPopup={isChatPopup} openedConversation={openedConversation} id={memoizedChatDetails.id} defaulOpentChecklist={defaulOpentChecklist} />
                </div>}
                {isChatMessagesLoading && (
                    <div className='relative overflow-hidden px-8 mt-2  flex-auto'>
                        <ChatMsgLoader />
                    </div>

                )}

                {(!isChatMessagesLoading || chatGptQueryParams) && (
                    <MessagesList isSubHeaderVisible={isSubHeaderVisible} memoizedMessages={memoizedMessages} isChatMinimized={isChatMinimized} unReadMessageId={unReadMessageId} openedConversation={openedConversation} onClickReplyMessage={onClickReplyMessage} onReplyClick={onReplyClick} replyToMessage={replyToMessage} replyShow={replyShow} showChatSubHeader={false} firstMessageRef={firstMessageRef} scrollDivRef={scrollDivRef} isCurrentChatLoading={isCurrentChatLoading} handleScroll={handleScroll} isChatPopup={isChatPopup} />
                )}

                <div className={`flex-none ${isChatMinimized ? 'pointer-events-none' : ''}`}>
                    <TypingUsers users={mpConversationUserTyping?.[chat_id]} additionalClasses='bg-white pl-2 py-1' maxUsernamesToShow={5} />
                    <MessageInput
                        chat_id={chat_id}
                        ref={messageInputRef}
                        showAllTag={openedConversation?.type !== chatType.SINGLE}
                        getLatestConversationMessages={getLatestConversationMessages}
                        closeReply={closeReply}
                        replyShow={replyShow}
                        setReplyShow={setReplyShow}
                        replyToMessage={replyToMessage}
                        scrollToBottom={scrollToBottom}
                        showDoubleHash={openedConversation?.type === chatType.GROUP}
                        ticketId={ticketId}
                        isSupportTicket={isSupportTicket}
                        isChatPopup={isChatPopup}
                        uuid={uuid}
                        type={openedConversation?.type}
                    />
                </div>
                {(showScrollButton && !isChatPopup) && <Scroller openedConversationUnreadableMessageCount={openedConversationUnreadableMessageCount} getLatestConversationMessages={getLatestConversationMessages} />}
            </div>
        </div>
    );
}


export const getLastVisibleElementId = ({ scrollableDivRef }) => {
    const scrollableDiv = scrollableDivRef.current;
    const elements = scrollableDiv.querySelectorAll('.message_class_for_scroll');

    let lastVisible = null;

    for (let i = elements.length - 1; i >= 0; i--) {
        const element = elements[i];
        const rect = element.getBoundingClientRect();

        if (rect.top < scrollableDiv.clientHeight) {
            lastVisible = element;
            break;
        }
    }

    return lastVisible ? lastVisible.id : undefined;
};

export const RenderScrollButton = ({ openedConversationUnreadableMessageCount, getLatestConversationMessages }) => {
    return <div
        style={{ right: '2.8%', bottom: '4.5rem' }}
        className='absolute cursor-pointer border flex place-content-center bg-scogoprimary rounded-md outline-0 border-none opacity-75'
    >
        <span onClick={() => getLatestConversationMessages(500)} className='material-icons text-white'>
            expand_more
        </span>
        {openedConversationUnreadableMessageCount ? (
            <span
                className={`absolute  inline-flex items-center justify-center px-2 py-1 text-font10 font-bold leading-none text-white transform translate-x-1/2 -translate-y-1/2 bg-scogoorange rounded-full notificationBadge`}
                style={{
                    top: '2%',
                    right: '1%',
                }}
            >
                {openedConversationUnreadableMessageCount}
            </span>
        ) : (
            <></>
        )}
    </div>
}

export const isDateAreSame = (a, b) => {
    return a && b && moment(a).format('dd/MM/Y') === moment(b).format('dd/MM/Y');
};